﻿/**
 * General JS Utilities
 * 
 * */
export const utils = {
    /**
     * Checks for the element and adds a class to the element's classList
     * 
     * @param {HTMLElement} el
     * @param {string} classes
     */
    classListAdd: function (el, classes) {
        if (el !== null) {
            el.classList.add(classes);
        }
    },

    /**
     * Checks for the element and removes a class to the element's classList
     *
     * @param {HTMLElement} el
     * @param {string} classes
     */
    classListRemove: function (el, classes) {
        if (el !== null) {
            el.classList.remove(classes);
        }
    },

    /**
     * Takes in a target element id and a scrolloffset and scrolls to that position
     * 
     * @param {string} elementId
     * @param {number} scrollOffset
     */
    scrollToElement: function (elementId, scrollOffset = 0) {
        event.preventDefault();
        const targetEl = document.getElementById(elementId);

        if (targetEl) {
            window.scrollTo({
                top: targetEl.offsetTop - scrollOffset,
                left: 0,
                behavior: 'smooth',
            });
        }
    },

    /**
     * Basic debounce function
     * 
     * @param {function} func
     * @param {number} wait
     * @returns {function}
     */
    debounce: function (func, wait) {
        let timeout = null;

        return function () {
            const args = arguments;

            window.clearTimeout(timeout);

            timeout = window.setTimeout(function () {
                func.apply(null, args)
            }, wait);
        };
	}
};
